<section class="main-contact-area {{pb}} {{pt}}">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="contact-wrap contact-pages mb-0">
                    <section
                        style="height: 350px"
                        class="hosting-solution-area"
                    >
                        <div class="container">
                            <div class="hosting-solution-wrap">
                                <h2 style="margin-top: 125px">{{title}}</h2>
                            </div>
                        </div>

                        <div class="shape shape-two">
                            <img
                                src="assets/img/shape/hosting-solution-two.png"
                                alt=""
                            />
                        </div>
                    </section>

                    <div class="contact-form">
                        <form
                            #contactForm="ngForm"
                            (ngSubmit)="addMessage(contactForm)"
                            id="contactForm"
                        >
                            <div class="row">
                                <!-- Nombre -->
                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="name"
                                            ><strong>Nombre:</strong
                                            ><span class="required"
                                                >*</span
                                            ></label
                                        >
                                        <input
                                            id="name"
                                            [(ngModel)]="newMessage.name"
                                            name="name"
                                            required
                                            type="text"
                                            class="form-control"
                                            #name="ngModel"
                                        />

                                        <div
                                            *ngIf="name.invalid && name.touched"
                                            class="text-danger"
                                        >
                                            El nombre es obligatorio.
                                        </div>
                                    </div>
                                </div>

                                <!-- Tema -->
                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="topic"
                                            ><strong>Asunto:</strong
                                            ><span class="required"
                                                >*</span
                                            ></label
                                        >
                                        <input
                                            id="topic"
                                            type="text"
                                            [(ngModel)]="newMessage.topic"
                                            name="topic"
                                            required
                                            class="form-control"
                                            #topic="ngModel"
                                        />
                                        <div
                                            *ngIf="topic.invalid && topic.touched"
                                            class="text-danger"
                                        >
                                            El asunto es obligatorio.
                                        </div>
                                    </div>
                                </div>

                                <!-- Correo Electrónico -->
                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="email">
                                            <strong>Correo Electrónico:</strong
                                            ><span class="required">*</span>
                                        </label>
                                        <input
                                            id="email"
                                            [(ngModel)]="newMessage.email"
                                            type="email"
                                            required
                                            name="email"
                                            class="form-control"
                                            #email="ngModel"
                                            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                                        />
                                        <div
                                            *ngIf="email.invalid && email.touched"
                                            class="text-danger"
                                        >
                                            <span *ngIf="email.errors?.required"
                                                >El correo es obligatorio.</span
                                            >
                                            <span *ngIf="email.errors?.pattern"
                                                >Formato de correo
                                                inválido.</span
                                            >
                                        </div>
                                    </div>
                                </div>
                                <!-- Teléfono -->
                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="phone-number"
                                            ><strong>Teléfono:</strong
                                            ><span class="required"
                                                >*</span
                                            ></label
                                        >
                                        <input
                                            id="phone-number"
                                            type="text"
                                            [(ngModel)]="newMessage.phone"
                                            name="phone-number"
                                            pattern="[0-9]{10}"
                                            required
                                            class="form-control"
                                            #phone="ngModel"
                                        />
                                        <div
                                            *ngIf="phone.invalid && phone.touched"
                                            class="text-danger"
                                        >
                                            <span *ngIf="phone.errors?.required"
                                                >El teléfono es
                                                obligatorio.</span
                                            >
                                            <span *ngIf="phone.errors?.pattern"
                                                >Debe ser un número de 10
                                                dígitos.</span
                                            >
                                        </div>
                                    </div>
                                </div>

                                <!-- Mensaje -->

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label for="message"
                                            ><strong>Mensaje:</strong
                                            ><span class="required"
                                                >*</span
                                            ></label
                                        >

                                        <html-editor
                                            [items]="htmlEditorItems"
                                            [reset]="resetEditor"
                                            [cssClass]="cssClass"
                                            [shouldNotGroupWhenFull]="shouldNotGroupWhenFull"
                                            [menuBarVisible]="htmlEditorMenuBarVisible"
                                            (ContentSanitized)="getContent($event)"
                                        ></html-editor>
                                        <div
                                            *ngIf="messageStatus"
                                            class="text-danger"
                                        >
                                            El mensaje es obligatorio.
                                        </div>
                                    </div>
                                </div>

                                <!-- Botón de Envío Deshabilitado Si el Formulario No es Válido -->
                                <div class="col-lg-12 col-md-12">
                                    <button
                                        type="submit"
                                        class="default-btn btn-two"
                                        [disabled]="contactForm.invalid || sanitizedContent==''"
                                    >
                                        Enviar mensaje
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
